//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import AddressSection from "@Shared/components/sections/address-section.vue";
import PhoneInput from "@Shared/components/inputs/phone-input.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PersonalDetails",
  components: {
    AddressSection,
    PhoneInput,
    MaterialInput
  },
  mixins: [validationMixin],
  validations: {
    givenName: {
      required
    },
    familyName: {
      required
    },
    email: {
      required
    },
    phoneNumber: {
      required
    },
    timezone: {
      required
    }
  },
  props: {
    userDetails: {
      type: Object,
      required: true
    },
    accountDetails: {
      type: Object,
      required: true
    },
    portal: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      givenName: this.userDetails.givenName,
      middleName: this.userDetails.middleName,
      familyName: this.userDetails.familyName,
      email: this.userDetails.email,
      phoneNumber: this.userDetails.phoneNumber,
      altPhoneNumber: this.userDetails.altPhoneNumber,
      address: this.userDetails.address,
      timezone: this.accountDetails.timezone,
      loading: false
    };
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initTimezones();
    });
  },
  methods: {
    handleInitialSubmit() {
      this.$emit("initial-submit");
    },
    handleSubmit() {
      if (this.portal === "broker" || this.isFormValid) {
        const data = {
          givenName: this.givenName,
          middleName: this.middleName,
          familyName: this.familyName,
          email: this.email,
          phoneNumber: this.phoneNumber,
          altPhoneNumber: this.altPhoneNumber,
          address: this.address,
          timezone: this.timezone
        };
        this.$emit("submit", data);
      }
    },
    initTimezones() {
      const timezoneSelect = $("#timezone-select");
      timezoneSelect.betterTimezone({
        showIANA: true,
        showOptgroups: true,
        placeholder: "Please select a timezone",
        width: "style"
      });
      timezoneSelect.val(this.timezone).trigger("change");
      timezoneSelect.on("change", event => {
        this.timezone = event.target.value;
        this.handleFormChange();
      });
    },
    handleFormChange() {
      this.$emit("form-change", "personalDetails");
      this.$emit("allow-save", this.isFormValid);
    }
  }
});